import clsx from 'clsx'
import Image from 'next/image'

import { addTestId } from 'shared/utils/tests'

import styles from './ProductSet.module.scss'

type ProductSetProps = {
  onClick: () => void
  children: React.ReactNode | string
  active?: boolean
  wider?: boolean
}

const ProductSet = (props: ProductSetProps): React.ReactNode => {
  const { onClick, children, active, wider } = props

  return (
    <button
      onClick={onClick}
      className={clsx(styles.root, {
        [styles.wider]: wider,
        [styles.active]: active
      })}
      {...addTestId('product-set-variant-button')}
    >
      {children}
      {active && (
        <div
          className={styles.icon}
          {...addTestId('product-page-quantity-jump-icon')}
        >
          <Image
            src={'/static/icons/check.svg'}
            alt='Wybrany wariant'
            width={13}
            height={10}
          />
        </div>
      )}
    </button>
  )
}

export default ProductSet
